import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";

const state = {
  templates: null,
  currentTemplate: null,
  currentTemplateMeta: null,
  currentTemplateSnippets: null,
  currentTemplateSnippetsMeta: null,
  currentTemplateSnippet: null,
  templateLibraryFolders: null,
  templateBuilderSession: null,
};
const getters = {
  templates_get_templates: (state) => {
    return state.templates;
  },
  templates_get_current_template_meta: (state) => {
    return state.currentTemplateMeta;
  },
  templates_get_current_template_snippets: (state) => {
    return state.currentTemplateSnippets;
  },
  templates_get_current_template_snippets_meta: (state) => {
    return state.currentTemplateSnippetsMeta;
  },
  templates_get_current_template_snippet: (state) => {
    return state.currentTemplateSnippet;
  },
  templates_get_current_template: (state) => {
    return state.currentTemplate;
  },
  templates_get_template_builder_session: (state) => {
    return state.templateBuilderSession;
  },
  templates_get_template_library_folders: (state) => {
    return state.templateLibraryFolders;
  },
};
const mutations = {
  TEAMS_SET_TEMPLATES(state, templates) {
    state.templates = templates;
  },
  TEAMS_SET_CURRENT_TEMPLATE(state, template) {
    state.currentTemplate = template.data;
    state.currentTemplateMeta = template.meta;
  },
  TEAMS_SET_CURRENT_TEMPLATE_SNIPPETS(state, snippets) {
    state.currentTemplateSnippets = snippets.data;
    state.currentTemplateSnippetsMeta = snippets.meta;
  },
  TEAMS_SET_CURRENT_TEMPLATE_SNIPPET(state, snippet) {
    state.currentTemplateSnippet = snippet.data;
    state.currentTemplateSnippetsMeta = snippet.meta;
  },
  TEAMS_SET_TEMPLATE_BUILDER_SESSION(state, templateBuilderSession) {
    state.templateBuilderSession = templateBuilderSession;
  },
  TEMPLATES_SET_TEMPLATE_FOLDERS(state, folders) {
    state.templateLibraryFolders = folders;
    // const f = folders.sort((a, b) => (a.title > b.title ? 1 : b.title > a.title ? -1 : 0));
    // Vue.set(state.library, "folders", f);
  },
};
const actions = {
  /**
   * Execute an API call for the template end point.
   * The following actions are supported:
   *
   * - duplicate
   * - createFile
   * - deleteFile
   * - updateTemplateSettings
   * - undoTemplateDraftChanges
   * - publishTemplateDraft
   *
   * @param commit
   * @param dispatch
   * @param rootState
   * @param payload
   * @param apiMethod
   * @returns {*}
   */
  templateApiRequest({ commit, dispatch, rootState }, payload = {}) {
    if (!payload.data) {
      payload.data = {};
    }

    console.log("templateApiRequest: ", payload);

    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          let apiMethod = payload.apiMethod;
          let promise;

          if (apiMethod === "duplicate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplateDuplicatePost(params, payload.data);
          } else if (apiMethod === "createFile") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplateFoldersTfolderFilesPost(params, payload.data);
          } else if (apiMethod === "updateTemplateSettings") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplateDraftsDraftPut(params, payload.data);
          } else if (apiMethod === "undoTemplateDraftChanges") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplateUndoPut(params, payload.data);
          } else if (apiMethod === "publishTemplateDraft") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplatePublishPut(params, payload.data);
          } else if (apiMethod === "deleteTemplate") {
            promise = $api(
              rootState.auth.teams[$router.currentRoute.params.team].apiConfig
            ).teamTemplatesTemplateDelete(params, payload);
          } else {
            console.log("invalid api method: " + apiMethod);
            reject("invalid api method: " + apiMethod);
          }

          promise
            .then((res) => {
              console.log("response of '" + apiMethod + "': ", res);
              resolve(res.data.data);
              commit("GLOBAL_LOADING_ENDED");
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamTemplates({ commit, dispatch, rootState }, payload = { params: {}, customLoading: false }) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_active_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        with_locale:
          typeof payload.params.with_locale !== "undefined" && payload.params.with_locale !== null
            ? payload.params.with_locale
            : "",
        without_locale:
          typeof payload.params.without_locale !== "undefined" && payload.params.without_locale !== null
            ? payload.params.without_locale
            : "",
        with_theme:
          typeof payload.params.with_theme !== "undefined" && payload.params.with_theme !== null
            ? payload.params.with_theme
            : "",
        without_theme:
          typeof payload.params.without_theme !== "undefined" && payload.params.without_theme !== null
            ? payload.params.without_theme
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesGet(params)
            .then((res) => {
              console.log("teamTemplatesGet", res.data.data);
              commit("TEAMS_SET_TEMPLATES", res.data.data);
              if (payload.setListsSettings) {
                commit("GLOBAL_SET_LISTS_SETTINGS", {
                  list: "templates",
                  pagination: {
                    page: res.data.meta.pagination.current_page,
                    perPage: res.data.meta.pagination.per_page,
                    lastPage: res.data.meta.pagination.last_page,
                    total: res.data.meta.pagination.total,
                  },
                  order: {
                    col: params.order_col,
                    dir: params.order_dir,
                  },
                  search: params.search,
                  filter: {
                    with_locale: params.with_locale,
                    without_locale: params.without_locale,
                    with_theme: params.with_theme,
                    without_theme: params.without_theme,
                  },
                });
              }
              // commit('TEAMS_SET_TEMPLATES_PAGINATION', res.data.meta.pagination)
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplateSnippets({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        template: payload.template,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "15",
        order_col: payload.params.order_col ? payload.params.order_col : "last_active_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "DESC",
        search: payload.params.search ? payload.params.search : "",
        is_text:
          typeof payload.params.is_text !== "undefined" && payload.params.is_text !== null
            ? payload.params.is_text
            : "",
        is_email:
          typeof payload.params.is_email !== "undefined" && payload.params.is_email !== null
            ? payload.params.is_email
            : "",
        is_default:
          typeof payload.params.is_default !== "undefined" && payload.params.is_default !== null
            ? payload.params.is_default
            : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsGet(params)
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsGet", res.data);
              commit("TEAMS_SET_CURRENT_TEMPLATE_SNIPPETS", res.data);
              commit("GLOBAL_SET_LISTS_SETTINGS", {
                list: "templateSnippets",
                pagination: {
                  page: res.data.meta.pagination.current_page,
                  perPage: res.data.meta.pagination.per_page,
                  lastPage: res.data.meta.pagination.last_page,
                  total: res.data.meta.pagination.total,
                },
                order: {
                  col: params.order_col,
                  dir: params.order_dir,
                },
                filter: {
                  is_text: params.is_text,
                  is_email: params.is_email,
                  is_default: params.is_default,
                },
              });
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplateSnippet({ commit, dispatch, rootState }, payload = {}) {
    commit("TEAMS_SET_CURRENT_TEMPLATE_SNIPPET", { data: null, meta: null });
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      payload.params = {
        template: payload.template,
        snippet: payload.uid,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsSnippetGet(params)
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsSnippetGet", res.data);
              commit("TEAMS_SET_CURRENT_TEMPLATE_SNIPPET", res.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createTemplateSnippet({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsPost(params, payload.data)
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsPost", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              commit("GLOBAL_LOADING_ENDED");
              $errors.handle(err.response);
              reject(err);
            });
        })
        .catch((err) => {
          commit("GLOBAL_LOADING_ENDED");
          $errors.handle(err.response);
          reject(err);
        });
    });
  },
  editTemplateSnippet({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsSnippetPut(params, payload.data)
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsSnippetPut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  deleteTemplateSnippet({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsSnippetDelete(params, {})
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsSnippetDelete", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(true);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  setDefaultTemplateSnippet({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateSnippetsSnippetDefaultPut(params, [])
            .then((res) => {
              console.log("teamTemplatesTemplateSnippetsSnippetDefaultPut", res);
              commit("GLOBAL_LOADING_ENDED");
              resolve(true);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplate({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        template: payload.template,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateGet(params)
            .then((res) => {
              console.log("teamTemplatesTemplateGet", res);
              commit("TEAMS_SET_CURRENT_TEMPLATE", res.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { name: "template" });
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  createTemplate({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", {})
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesPost(params, payload.data)
            .then((res) => {
              console.log("teamTemplatesPost", res);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editTemplate({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplatePut(params, payload.data)
            .then((res) => {
              console.log("teamTemplatesTemplatePut", res);
              if (!payload.redirect) commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamTemplateBuilderSession({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateBuilderSessionPost(params, payload.data)
            .then((res) => {
              console.log("teamTemplatesTemplateBuilderSessionPost", res);
              commit("TEAMS_SET_TEMPLATE_BUILDER_SESSION", res.data.data);
              resolve();
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplateLibraryFolders({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        template: payload.params.template,
        page: payload.params.page ? payload.params.page : "1",
        per_page: payload.params.per_page ? payload.params.per_page : "150",
        order_col: payload.params.order_col ? payload.params.order_col : "created_at",
        order_dir: payload.params.order_dir ? payload.params.order_dir : "ASC",
        root_folder: payload.params.root_folder ? payload.params.root_folder : "",
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateFoldersGet(params)
            .then((res) => {
              console.log("teamTemplatesTemplateFoldersGet", res.data.data);
              commit("TEMPLATES_SET_TEMPLATE_FOLDERS", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplateLibraryFile({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        template: payload.template,
        tfolder: payload.folder,
        file: payload.file,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateFoldersTfolderFilesFileGet(params)
            .then((res) => {
              console.log("teamTemplatesTemplateFoldersTfolderFilesFileGet", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTemplateFilePreview({ commit, dispatch, rootState }, payload = {}) {
    return new Promise((resolve, reject) => {
      !payload.customLoading && commit("GLOBAL_LOADING_STARTED");
      if (!payload.params) payload.params = {};
      payload.params = {
        template: payload.template,
        tfolder: payload.folder,
        file: payload.file,
        page: payload.params.page ? payload.params.page : "1",
        width: payload.params.width ? payload.params.width : "100",
        height: payload.params.height ? payload.params.height : "100",
        rendermethod: payload.params.rendermethod ? payload.params.rendermethod : "fit",
        redirect: payload.params.redirect ? payload.params.redirect : false,
      };
      dispatch("prepareRequest", payload.params)
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamTemplatesTemplateFoldersTfolderFilesFilePreviewImageRendermethodPageWidthHeightGet(params)
            .then((res) => {
              console.log(
                "teamTemplatesTemplateFoldersTfolderFilesFilePreviewImageRendermethodPageWidthHeightGet",
                res.data.data
              );
              commit("GLOBAL_LOADING_ENDED");
              resolve(res.data.data.redirect);
            })
            .catch((err) => {
              console.log(err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
